import { createApp } from 'vue'
import App from './App.vue'
import Quasar from 'quasar/src/vue-plugin.js';import Notify from 'quasar/src/plugins/Notify.js';import Loading from 'quasar/src/plugins/Loading.js';
import quasarUserOptions from './quasar-user-options'
import router from './router'
import axios from 'axios'
import store from "./store";
import Vuex from 'vuex'
import { VueReCaptcha } from 'vue-recaptcha-v3'
import { VuelidatePlugin } from '@vuelidate/core'
import RecaptchaHelpers from './helpers/RecaptchaHelpers'
import ChaClassHelpers from './helpers/ChaClassHelpers'
import moment from 'moment'

const app = createApp(App)

axios.defaults.baseURL = process.env.NODE_ENV === 'production' ? process.env.VUE_APP_PRODUCTION_BASE_URL : process.env.VUE_APP_LOCAL_BASE_URL

axios.interceptors.request.use((config) => {
    const token = localStorage.getItem('authToken')
    const captcha = localStorage.getItem('captcha')

    config.headers.Authorization =  `Bearer ${token}`;
    config.headers.captcha = captcha;

    return config;
  }, (error) => {
    return Promise.reject(error);
  });

  axios.interceptors.response.use((response) => {
      return response;
    }, (error) => {
      if (error.response.status === 401) {
        router.push({ name: 'Dashboard' })
        store.dispatch('user/clearData')
        localStorage.clear()
      }

      return Promise.reject(error);
    });

  // Register global mixin
const mixin = {
  methods: {
    recaptchaLoad: RecaptchaHelpers.recaptchaLoad,
    getClassToImageName: ChaClassHelpers.getClassToImageName,
    getItemShopTabs: ChaClassHelpers.getItemShopTabs,
    getUserLevel: ChaClassHelpers.getUserLevel
  },
};

app.mixin(mixin);
app.use(moment)
app.use(router)
app.use(store)
app.use(Vuex)
app.use(Quasar, {
    plugins: {
        Notify,
        Loading
    },
    config: {
      notify: { /* look at QuasarConfOptions from the API card */ }
    }
})
app.use(quasarUserOptions)
app.use(VueReCaptcha, { siteKey: '6LdJ_2ImAAAAAD9eVr2P1_eI8zOZgBtAlyTIX0e5' })
app.use(VuelidatePlugin)
app.mount('#app')